import { useEffect } from "react";
import api from "../lib/api";
import { applySettingsToHead } from "../lib/headInject";

// Fetches site settings and injects GA / GTM / Search Console / custom head markup.
const SeoInjector = () => {
  useEffect(() => {
    let cancelled = false;
    api
      .get("/settings")
      .then(({ data }) => {
        if (!cancelled) applySettingsToHead(data);
      })
      .catch(() => {
        /* settings are optional */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return null;
};

export default SeoInjector;
